<template>
  <v-container fluid>
    <h2>{{ title }}</h2>
    <v-tabs v-model="activeTab" background-color="white">
      <v-tab v-for="item in items" :key="item.key">
        {{ item.key }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="item in items" :key="item.key">
        <v-data-table
          :headers="headers"
          :items="item.transactions"
          :items-per-page="-1"
          :disable-pagination="true"
          hide-default-footer
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:item.deposit="{ item }">
            {{ formatCurrency(item.deposit, item.currency) }}
          </template>
          <template v-slot:item.withdrawal="{ item }">
            {{ formatCurrency(item.withdrawal, item.currency) }}
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
export default {
  props: {
    listData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      activeTab: 0,
      headers: [
        { text: 'Account Number', value: 'accountNumber' },
        { text: 'Date', value: 'date' },
        { text: 'Type', value: 'type' },
        { text: 'Description', value: 'desc' },
        { text: 'Deposit', value: 'deposit' },
        { text: 'Withdrawal', value: 'withdrawal' }
      ]
    }
  },
  computed: {
    items() {
      return Object.keys(this.listData)
        .map(key => ({
          key,
          transactions: this.listData[key].map(transaction => ({
            ...transaction,
            deposit: transaction.deposit || 0,
            withdrawal: transaction.withdrawal || 0
          }))
        }))
        .sort((a, b) => a.key.localeCompare(b.key))
    }
  },
  methods: {
    formatCurrency(value, currency) {
      if (!value) return ''
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
          parseFloat(value.toString().replace(/,/g, ''))
        )
      } catch (error) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: "HKD", currencyDisplay: "narrowSymbol" }).format(
          parseFloat(value.toString().replace(/,/g, ''))
        )
      }
    }
  }
}
</script>

<style scoped>
/* Set tab background to white */
:deep(.v-tabs-bar) {
  background-color: white !important;
}

/* Set tab text color to blue for both active and inactive tabs */
:deep(.v-tab) {
  color: rgb(25, 118, 210) !important;
  max-width: 300px !important; /* Set maximum width for each tab */
  white-space: normal; /* Allow text to wrap if needed */
  padding: 0 10px; /* Adjust padding for better appearance */
}

/* Ensure active tab text remains blue */
:deep(.v-tab--active) {
  color: rgb(25, 118, 210) !important;
}

/* Optional: Style the slider (active tab indicator) to blue */
:deep(.v-tabs-slider) {
  background-color: rgb(25, 118, 210) !important;
}
</style>
